import { Directive, ElementRef, HostListener, Optional, Self } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector:
    'input[matInput],textarea[matInput],input[formControlName],textarea[formControlName],input[ngModel],textarea[ngModel]',
})
export class TrimOnBlurDirective {
  constructor(
    private readonly elementRef: ElementRef<HTMLInputElement | HTMLTextAreaElement>,
    @Optional() @Self() private readonly ngControl?: NgControl
  ) {}

  @HostListener('blur')
  onBlur(): void {
    const element = this.elementRef.nativeElement;
    if (!this.shouldTrim(element)) {
      return;
    }

    const currentValue = element.value;
    if (typeof currentValue !== 'string') {
      return;
    }

    const trimmedValue = this.normalizeWhitespace(currentValue);

    if (this.ngControl?.control) {
      if (trimmedValue !== currentValue) {
        this.ngControl.control.setValue(trimmedValue);
      }
      this.ngControl.control.markAsTouched();
      this.ngControl.control.updateValueAndValidity({ onlySelf: true });
      return;
    }

    if (trimmedValue !== currentValue) {
      element.value = trimmedValue;
      element.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }

  private normalizeWhitespace(value: string): string {
    return value.replace(/ {2,}/g, ' ').trim();
  }

  private shouldTrim(element: HTMLInputElement | HTMLTextAreaElement): boolean {
    if (element.disabled || element.readOnly) {
      return false;
    }

    if (element instanceof HTMLTextAreaElement) {
      return true;
    }

    const nonTrimInputTypes = new Set([
      'checkbox',
      'radio',
      'hidden',
      'file',
      'password',
      'number',
      'range',
      'color',
      'date',
      'datetime-local',
      'month',
      'time',
      'week',
    ]);

    return !nonTrimInputTypes.has((element.type || 'text').toLowerCase());
  }
}
